<template>
    <!-- Wins fill the ring clockwise from the top, losses are the red remainder. Size it with a
         class on the component; the ring keeps its proportions. -->
    <div class="relative shrink-0">
        <svg viewBox="0 0 100 100" class="size-full -rotate-90" aria-hidden="true">
            <circle
                cx="50"
                cy="50"
                r="42.5"
                fill="none"
                stroke-width="15"
                :class="hasGames ? 'stroke-red-600' : 'stroke-stroke-2'"
            />
            <circle
                v-if="percentage > 0"
                cx="50"
                cy="50"
                r="42.5"
                fill="none"
                stroke-width="15"
                pathLength="100"
                :stroke-dasharray="`${percentage} 100`"
                class="stroke-green-600"
            />
        </svg>
        <span
            v-if="$slots.default"
            class="font-title absolute inset-0 flex items-center justify-center text-sm leading-[14px] font-extrabold"
        >
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'DonutChart',
    props: {
        percentage: {
            type: Number,
            required: true,
        },
        hasGames: {
            type: Boolean,
            default: true,
        },
    },
}
</script>
